import { render } from "./OrganizationReport.vue?vue&type=template&id=4ba29e2e"
import script from "./OrganizationReport.vue?vue&type=script&lang=js"
export * from "./OrganizationReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__